<template>
  <div class="months-checkbox">
    <ul class="list-unstyled">
      <li v-for="item in months" :key="item.month">
        <div class="month-checkbox">
          <input
            type="checkbox"
            :id="_uid + '-' + item.month"
            v-bind:checked="item.checked"
            v-on:input="toggle($event, item)"
          />
          <label :for="_uid + '-' + item.month">
            <span v-bind:class="{ checked: item.checked }">{{item.month | month}}</span>
          </label>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ["value"],
  computed: {
    months() {
      let value = this.value.reduce((acc, cur) => {
        acc[cur] = true;
        return acc;
      }, {});

      return [...Array(12).keys()].map(key => {
        return {
          month: key + 1,
          checked: !!value[key + 1]
        };
      });
    }
  },
  methods: {
    toggle(event, item) {
      item.checked = event.target.checked;

      let value = this.months
        .filter(item => item.checked)
        .map(item => item.month);

      this.$emit("input", value);
      this.$forceUpdate();
    }
  }
};
</script>

<style lang="scss" scoped>
.months-checkbox {
  ul {
    display: flex;

    li {
      margin: 3px;
    }

    .month-checkbox {
      position: relative;
      background: white;
      // width: 2rem;
      height: 2rem;
      border-radius: 1rem;
      border: 2px solid #ff9100;
      user-select: none;

      label {
        display: block;
        // width: 100%;
        // height: 100%;
        padding: 0px 5px;
        cursor: pointer;

        & > span {
          // position: absolute;
          // left: 50%;
          // top: 50%;
          // transform: translate(-50%, -50%);
          color: #7cb342;
          opacity: 0.3;
          transition: all 0.25s;
          // font-size: 0.9rem;
        }
      }

      input[type="checkbox"] {
        position: absolute;
        visibility: hidden;
      }

      .checked {
        opacity: 1;
      }
    }
  }
}
</style>